import { render, staticRenderFns } from "./Luo5.vue?vue&type=template&id=63d7c0e1&"
import script from "./Luo5.vue?vue&type=script&lang=js&"
export * from "./Luo5.vue?vue&type=script&lang=js&"
import style0 from "./Luo5.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports